import { Button, Tooltip } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { FunctionComponent } from 'react';

export interface IButtonCallbackCellRendererParams<T> {
  prefixText?: string;
  buttonText: string;
  callback: (rowData: T) => void;
  variant?: 'text' | 'outlined' | 'contained';
  isDisabled?: boolean;
  tooltip?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
}

export interface IButtonCallbackCellRendererProps extends ICellRendererParams, IButtonCallbackCellRendererParams<unknown> {}

const ButtonCallbackCellRenderer: FunctionComponent<IButtonCallbackCellRendererProps> = ({
  data,
  callback,
  buttonText,
  variant = 'contained',
  isDisabled = false,
  prefixText,
  tooltip,
  color = 'primary',
}) => {
  const handleClick = () => {
    if (data) {
      callback(data);
    }
  };

  return (
    <Tooltip title={tooltip}>
      <div className="flex flex-row h-full items-center gap-2">
        {prefixText}
        <Button variant={variant} onClick={handleClick} disabled={isDisabled} color={color}>
          {buttonText}
        </Button>
      </div>
    </Tooltip>
  );
};

export default ButtonCallbackCellRenderer;
